import { render, staticRenderFns } from "./MObj_history.vue?vue&type=template&id=54421e34"
import script from "./MObj_history.vue?vue&type=script&lang=js"
export * from "./MObj_history.vue?vue&type=script&lang=js"
import style0 from "./MObj_history.vue?vue&type=style&index=0&id=54421e34&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports